import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-blog-grid',
    templateUrl: './blog-grid.component.html',
    styleUrls: ['./blog-grid.component.scss'],
    standalone: false
})
export class BlogGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
